var angular = require('angular')
var StickyTable = require('aem-libs/src/stickytable.js').StickyTable
var StickyTableHeader = require('aem-libs/src/stickytableheader.js').StickyTableHeader

angular.module('AemCspsFundsPortfolio')
  .controller('AemCspsFundsPortfolioCtrl', ctrl)

ctrl.$inject = ['appLoader', 'pensionService', 'wgService', '$timeout']

function ctrl (appLoader, pensionService, wgService, $timeout) {
  var vm = this

  vm.$onInit = function () {
    vm.data = []
    vm.showError = false
    vm.noData = false
    var fundId = wgService.getParams().fundId
    var promise = fundId === 'tf' ? pensionService.transformedFundPortfolio() : pensionService.portfolio(fundId)
    promise
      .then(function (response) {
        vm.noData = !response.data || !response.data.length
        vm.data = response.data
      })
      .catch(function () {
        vm.showError = true
      })
      .finally(function () {
        appLoader.hide()
        $timeout(StickyTableHeader)
        $timeout(StickyTable)
      })
  }
}
